export const MERCADO_PAGO_ONIX = ['7569', '7570', '7571', '7588', '7587', '7586', '7585', '7630', '7629', '7628'];

export const isMercadoPagoOnix = (onixCode: string | null = ''): boolean =>
  MERCADO_PAGO_ONIX.includes(onixCode?.toString() || '');
